export var ModalState;
(function (ModalState) {
    ModalState["BIRTHDAY"] = "birthday";
    ModalState["SUCCESS"] = "success";
    ModalState["TERMS_AND_CONDITIONS"] = "terms_and_conditions";
})(ModalState || (ModalState = {}));
